import {
  LayoutDashboard,
  Users,
  CalendarDays,
  Clock,
  NotebookPen,
  ClipboardList,
  Receipt,
  BarChart3,
  MessageSquare,
  UserPlus,
  Briefcase,
  Layers,
  ListOrdered,
  GitBranch,
  Building2,
  BedDouble,
  Megaphone,
  Plug,
  Bell,
  Settings,
} from "lucide-react"

/** Grouped app sidebar navigation (order = visual hierarchy). */
export const APP_NAV_GROUPS = [
  {
    id: "clinical",
    labelKey: "app.navGroupClinical",
    items: [
      { to: "/app/clients", labelKey: "app.nav.clients", icon: Users, feature: "clients" },
      { to: "/app/appointments", labelKey: "app.nav.appointments", icon: CalendarDays, feature: "appointments" },
      { to: "/app/waitlist", labelKey: "app.nav.waitlist", icon: Clock, feature: "waitlist" },
      { to: "/app/notes", labelKey: "app.nav.notes", icon: NotebookPen, feature: "notes_basic" },
      { to: "/app/care-plans", labelKey: "app.nav.carePlans", icon: ClipboardList, feature: "care_plans" },
      { to: "/app/referrals", labelKey: "app.nav.referrals", icon: UserPlus, feature: "referrals" },
    ],
  },
  {
    id: "finance",
    labelKey: "app.navGroupFinance",
    items: [
      { to: "/app/billing", labelKey: "app.nav.billing", icon: Receipt, feature: "billing" },
      { to: "/app/analytics", labelKey: "app.nav.analytics", icon: BarChart3, feature: "analytics_basic" },
    ],
  },
  {
    id: "operations",
    labelKey: "app.navGroupOperations",
    items: [
      { to: "/app/queues", labelKey: "app.nav.queues", icon: ListOrdered, feature: "queues" },
      { to: "/app/adt", labelKey: "app.nav.adt", icon: BedDouble, feature: "adt" },
      { to: "/app/network", labelKey: "app.nav.network", icon: Building2, feature: "multi_location" },
      { to: "/app/scheduling/resources", labelKey: "app.nav.schedulingResources", icon: Layers, feature: "scheduling_resources" },
    ],
  },
  {
    id: "engagement",
    labelKey: "app.navGroupEngagement",
    items: [
      { to: "/app/communications", labelKey: "app.nav.communications", icon: MessageSquare, feature: "communications" },
      { to: "/app/reminder-rules", labelKey: "app.nav.reminderRules", icon: Bell, feature: "appointments" },
      { to: "/app/workflows", labelKey: "app.nav.workflows", icon: GitBranch, feature: "workflows" },
      { to: "/app/campaigns", labelKey: "app.nav.campaigns", icon: Megaphone, feature: "campaigns" },
    ],
  },
  {
    id: "organization",
    labelKey: "app.navGroupOrganization",
    items: [
      { to: "/app/hr", labelKey: "app.nav.hr", icon: Briefcase, feature: "hr" },
      { to: "/app/integrations", labelKey: "app.nav.integrations", icon: Plug, feature: "clients" },
    ],
  },
]

export const APP_NAV_DASHBOARD = {
  to: "/app",
  labelKey: "app.nav.dashboard",
  icon: LayoutDashboard,
  end: true,
  feature: "clients",
}

export const APP_NAV_SETTINGS = {
  to: "/app/settings",
  labelKey: "app.nav.settings",
  icon: Settings,
  feature: "clients",
}

export function navTestId(path) {
  const slug = path.replace(/^\/app\/?/, "").replace(/\//g, "-")
  return slug ? `sidebar-${slug}` : "sidebar-dashboard"
}
